export enum SubscriptionStatus {
  Active = "ACTIVE",
  Canceled = "CANCELLED",
  Declined = "DECLINED",
  Expired = "EXPIRED",
  Frozen = "FROZEN",
  Pending = "PENDING",
}
